import { APP_INITIALIZER, ApplicationConfig } from "@angular/core";
import { provideRouter, Router } from "@angular/router";
import { routes } from "./app.routes";
import { provideHttpClient, withFetch } from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { TypePage } from "./contentful-content-types/page";
import { ContentfulService } from "./shared/services/contentful/contentful.service";

export function initializeApp(
  contenfulService: ContentfulService,
  router: Router
) {
  return () =>
    new Promise((resolve) => {
      contenfulService.getPages().subscribe((pages) => {
        const routes = pages.items.map(
          (page: TypePage) => page.fields["slug"] || ""
        );

        const updatedRouter = router.config;
        routes.forEach((route: any) => {
          const slicedRoute = route.replace("/", "");
          updatedRouter?.push({
            path: slicedRoute,
            loadComponent: () =>
              import("./dynamic-page/dynamic-page.component").then(
                (m) => m.DynamicPageComponent
              ),
            // you could add any data from the server here and get it from your component
          });
        });

        router.resetConfig([...updatedRouter]);
      });
      setTimeout(() => {
        resolve(true);
      });
    });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [ContentfulService, Router],
    },
  ],
};
